import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { AutocompleteOption } from '@models/types';
import i18nCountries from 'i18n-iso-countries';
import ar from 'i18n-iso-countries/langs/ar.json';
import de from 'i18n-iso-countries/langs/de.json';
import en from 'i18n-iso-countries/langs/en.json';
import es from 'i18n-iso-countries/langs/es.json';
import fr from 'i18n-iso-countries/langs/fr.json';
import pt from 'i18n-iso-countries/langs/pt.json';
import ru from 'i18n-iso-countries/langs/ru.json';

i18nCountries.registerLocale(en);
i18nCountries.registerLocale(ru);
i18nCountries.registerLocale(pt);
i18nCountries.registerLocale(es);
i18nCountries.registerLocale(de);
i18nCountries.registerLocale(fr);
i18nCountries.registerLocale(ar);

const countries = [
    {
        name: 'Andorra',
        'ALPHA-2': 'AD',
        'ALPHA-3': 'AND',
        NUMERIC: '020',
    },
    {
        name: 'United Arab Emirates',
        'ALPHA-2': 'AE',
        'ALPHA-3': 'ARE',
        NUMERIC: '784',
    },
    {
        name: 'Afghanistan',
        'ALPHA-2': 'AF',
        'ALPHA-3': 'AFG',
        NUMERIC: '004',
    },
    {
        name: 'Antigua and Barbuda',
        'ALPHA-2': 'AG',
        'ALPHA-3': 'ATG',
        NUMERIC: '028',
    },
    {
        name: 'Anguilla',
        'ALPHA-2': 'AI',
        'ALPHA-3': 'AIA',
        NUMERIC: '660',
    },
    {
        name: 'Albania',
        'ALPHA-2': 'AL',
        'ALPHA-3': 'ALB',
        NUMERIC: '008',
    },
    {
        name: 'Armenia',
        'ALPHA-2': 'AM',
        'ALPHA-3': 'ARM',
        NUMERIC: '051',
    },
    // {name: 'Amsterdam', 'ALPHA-2': 'AMS', 'ALPHA-3': '', NUMERIC: ''},
    {
        name: 'Angola',
        'ALPHA-2': 'AO',
        'ALPHA-3': 'AGO',
        NUMERIC: '024',
    },
    {
        name: 'Antartctica',
        'ALPHA-2': 'AQ',
        'ALPHA-3': 'ATA',
        NUMERIC: '010',
    },
    {
        name: 'Argentina',
        'ALPHA-2': 'AR',
        'ALPHA-3': 'ARG',
        NUMERIC: '032',
    },
    {
        name: 'American Samoa',
        'ALPHA-2': 'AS',
        'ALPHA-3': 'ASM',
        NUMERIC: '016',
    },
    {
        name: 'Austria',
        'ALPHA-2': 'AT',
        'ALPHA-3': 'AUT',
        NUMERIC: '040',
    },
    {
        name: 'Australia',
        'ALPHA-2': 'AU',
        'ALPHA-3': 'AUS',
        NUMERIC: '016',
    },
    {
        name: 'Aruba',
        'ALPHA-2': 'AW',
        'ALPHA-3': 'ABW',
        NUMERIC: '533',
    },
    {
        name: 'Aland Islands',
        'ALPHA-2': 'AX',
        'ALPHA-3': 'ALA',
        NUMERIC: '248',
    },
    {
        name: 'Azerbaijan',
        'ALPHA-2': 'AZ',
        'ALPHA-3': 'AZE',
        NUMERIC: '031',
    },
    {
        name: 'Bosnia and Herzegovina',
        'ALPHA-2': 'BA',
        'ALPHA-3': 'BIH',
        NUMERIC: '070',
    },
    {
        name: 'Barbados',
        'ALPHA-2': 'BB',
        'ALPHA-3': 'BRB',
        NUMERIC: '052',
    },
    {
        name: 'Bangladesh',
        'ALPHA-2': 'BD',
        'ALPHA-3': 'BGD',
        NUMERIC: '050',
    },
    {
        name: 'Belgium',
        'ALPHA-2': 'BE',
        'ALPHA-3': 'BEL',
        NUMERIC: '056',
    },
    {
        name: 'Burkina Faso',
        'ALPHA-2': 'BF',
        'ALPHA-3': 'BFA',
        NUMERIC: '854',
    },
    {
        name: 'Bulgaria',
        'ALPHA-2': 'BG',
        'ALPHA-3': 'BGR',
        NUMERIC: '100',
    },
    {
        name: 'Bahrain',
        'ALPHA-2': 'BH',
        'ALPHA-3': 'BHR',
        NUMERIC: '048',
    },
    {
        name: 'Burundi',
        'ALPHA-2': 'BI',
        'ALPHA-3': 'BDI',
        NUMERIC: '108',
    },
    {
        name: 'Benin',
        'ALPHA-2': 'BJ',
        'ALPHA-3': 'BEN',
        NUMERIC: '204',
    },
    {
        name: 'Saint Barthelemy',
        'ALPHA-2': 'BL',
        'ALPHA-3': 'BLM',
        NUMERIC: '652',
    },
    {
        name: 'Bermuda',
        'ALPHA-2': 'BM',
        'ALPHA-3': 'BMU',
        NUMERIC: '060',
    },
    {
        name: 'Brunei',
        'ALPHA-2': 'BN',
        'ALPHA-3': 'BRN',
        NUMERIC: '096',
    },
    {
        name: 'Bolivia',
        'ALPHA-2': 'BO',
        'ALPHA-3': 'BOL',
        NUMERIC: '068',
    },
    {
        name: 'Bonaire, Sint Eustatius and Saba',
        'ALPHA-2': 'BQ',
        'ALPHA-3': 'BES',
        NUMERIC: '535',
    },
    {
        name: 'Brazil',
        'ALPHA-2': 'BR',
        'ALPHA-3': 'BRA',
        NUMERIC: '076',
    },
    {
        name: 'Bahamas',
        'ALPHA-2': 'BS',
        'ALPHA-3': 'BHS',
        NUMERIC: '044',
    },
    {
        name: 'Bhutan',
        'ALPHA-2': 'BT',
        'ALPHA-3': 'BTN',
        NUMERIC: '064',
    },
    {
        name: 'Bouvet Island',
        'ALPHA-2': 'BV',
        'ALPHA-3': 'BVT',
        NUMERIC: '074',
    },
    {
        name: 'Botswana',
        'ALPHA-2': 'BW',
        'ALPHA-3': 'BWA',
        NUMERIC: '072',
    },
    {
        name: 'Belarus',
        'ALPHA-2': 'BY',
        'ALPHA-3': 'BLR',
        NUMERIC: '112',
    },
    {
        name: 'Belize',
        'ALPHA-2': 'BZ',
        'ALPHA-3': 'BLZ',
        NUMERIC: '084',
    },
    {
        name: 'Canada',
        'ALPHA-2': 'CA',
        'ALPHA-3': 'CAN',
        NUMERIC: '124',
    },
    {
        name: 'Cocos Islands',
        'ALPHA-2': 'CC',
        'ALPHA-3': 'CCK',
        NUMERIC: '166',
    },
    {
        name: 'Democratis Republic of Congo',
        'ALPHA-2': 'CD',
        'ALPHA-3': 'COD',
        NUMERIC: '180',
    },
    {
        name: 'Central African Republic',
        'ALPHA-2': 'CF',
        'ALPHA-3': 'CAF',
        NUMERIC: '140',
    },
    {
        name: 'Congo',
        'ALPHA-2': 'CG',
        'ALPHA-3': 'COG',
        NUMERIC: '178',
    },
    {
        name: 'Switzerland',
        'ALPHA-2': 'CH',
        'ALPHA-3': 'CHE',
        NUMERIC: '756',
    },
    {
        name: "Cote d'Ivoire",
        'ALPHA-2': 'CI',
        'ALPHA-3': 'CIV',
        NUMERIC: '384',
    },
    {
        name: 'Cook Island',
        'ALPHA-2': 'CK',
        'ALPHA-3': 'COK',
        NUMERIC: '184',
    },
    {
        name: 'Chile',
        'ALPHA-2': 'CL',
        'ALPHA-3': 'CHL',
        NUMERIC: '152',
    },
    {
        name: 'Cameroon',
        'ALPHA-2': 'CM',
        'ALPHA-3': 'CMR',
        NUMERIC: '120',
    },
    {
        name: 'China',
        'ALPHA-2': 'CN',
        'ALPHA-3': 'CHN',
        NUMERIC: '156',
    },
    {
        name: 'Colombia',
        'ALPHA-2': 'CO',
        'ALPHA-3': 'COL',
        NUMERIC: '170',
    },
    {
        name: 'Costa Rica',
        'ALPHA-2': 'CR',
        'ALPHA-3': 'CRI',
        NUMERIC: '188',
    },
    {
        name: 'Cuba',
        'ALPHA-2': 'CU',
        'ALPHA-3': 'CUB',
        NUMERIC: '192',
    },
    {
        name: 'Cape Verde',
        'ALPHA-2': 'CV',
        'ALPHA-3': 'CPV',
        NUMERIC: '132',
    },
    {
        name: 'Curacao',
        'ALPHA-2': 'CW',
        'ALPHA-3': 'CUW',
        NUMERIC: '531',
    },
    {
        name: 'Christmas Island',
        'ALPHA-2': 'CX',
        'ALPHA-3': 'CXR',
        NUMERIC: '162',
    },
    {
        name: 'Cyprus',
        'ALPHA-2': 'CY',
        'ALPHA-3': 'CYP',
        NUMERIC: '196',
    },
    {
        name: 'Czech Republic',
        'ALPHA-2': 'CZ',
        'ALPHA-3': 'CZE',
        NUMERIC: '203',
    },
    {
        name: 'Germany',
        'ALPHA-2': 'DE',
        'ALPHA-3': 'DEU',
        NUMERIC: '276',
    },
    {
        name: 'Djibouti',
        'ALPHA-2': 'DJ',
        'ALPHA-3': 'DJI',
        NUMERIC: '262',
    },
    {
        name: 'Denmark',
        'ALPHA-2': 'DK',
        'ALPHA-3': 'DNK',
        NUMERIC: '208',
    },
    {
        name: 'Dominica',
        'ALPHA-2': 'DM',
        'ALPHA-3': 'DMA',
        NUMERIC: '212',
    },
    {
        name: 'Dominican Republic',
        'ALPHA-2': 'DO',
        'ALPHA-3': 'DOM',
        NUMERIC: '214',
    },
    {
        name: 'Ecuador',
        'ALPHA-2': 'EC',
        'ALPHA-3': 'ECU',
        NUMERIC: '218',
    },
    {
        name: 'Estonia',
        'ALPHA-2': 'EE',
        'ALPHA-3': 'EST',
        NUMERIC: '233',
    },
    {
        name: 'Egypt',
        'ALPHA-2': 'EG',
        'ALPHA-3': 'EGY',
        NUMERIC: '818',
    },
    {
        name: 'Western Sahara',
        'ALPHA-2': 'EH',
        'ALPHA-3': 'ESH',
        NUMERIC: '732',
    },
    {
        name: 'Eritrea',
        'ALPHA-2': 'ER',
        'ALPHA-3': 'ERI',
        NUMERIC: '232',
    },
    {
        name: 'Spain',
        'ALPHA-2': 'ES',
        'ALPHA-3': 'ESP',
        NUMERIC: '724',
    },
    {
        name: 'Ethiopia',
        'ALPHA-2': 'ET',
        'ALPHA-3': 'ETH',
        NUMERIC: '231',
    },
    // {
    //     name: 'European Union',
    //     'ALPHA-2': 'EU',
    //     'ALPHA-3': '',
    //     NUMERIC: '',
    // },
    {
        name: 'Finland',
        'ALPHA-2': 'FI',
        'ALPHA-3': 'FIN',
        NUMERIC: '246',
    },
    {
        name: 'Fiji',
        'ALPHA-2': 'FJ',
        'ALPHA-3': 'FJI',
        NUMERIC: '242',
    },
    {
        name: 'Falkland Islands',
        'ALPHA-2': 'FK',
        'ALPHA-3': 'FLK',
        NUMERIC: '238',
    },
    {
        name: 'Micronesia (Federated States of)',
        'ALPHA-2': 'FM',
        'ALPHA-3': 'FSM',
        NUMERIC: '583',
    },
    {
        name: 'Faroe Island',
        'ALPHA-2': 'FO',
        'ALPHA-3': 'FRO',
        NUMERIC: '234',
    },
    {
        name: 'France',
        'ALPHA-2': 'FR',
        'ALPHA-3': 'FRA',
        NUMERIC: '250',
    },
    {
        name: 'Gabon',
        'ALPHA-2': 'GA',
        'ALPHA-3': 'GAB',
        NUMERIC: '266',
    },
    {
        name: 'United Kingdom of Great Britain and Northern Ireland',
        'ALPHA-2': 'GB',
        'ALPHA-3': 'GBR',
        NUMERIC: '826',
    },
    {
        name: 'Grenada',
        'ALPHA-2': 'GD',
        'ALPHA-3': 'GRD',
        NUMERIC: '308',
    },
    {
        name: 'Georgia',
        'ALPHA-2': 'GE',
        'ALPHA-3': 'GEO',
        NUMERIC: '268',
    },
    {
        name: 'French Guiana',
        'ALPHA-2': 'GF',
        'ALPHA-3': 'GUF',
        NUMERIC: '254',
    },
    {
        name: 'Guernsey',
        'ALPHA-2': 'GG',
        'ALPHA-3': 'GGY',
        NUMERIC: '831',
    },
    {
        name: 'Ghana',
        'ALPHA-2': 'GH',
        'ALPHA-3': 'GHA',
        NUMERIC: '288',
    },
    {
        name: 'Gibraltar',
        'ALPHA-2': 'GI',
        'ALPHA-3': 'GIB',
        NUMERIC: '292',
    },
    {
        name: 'Greenland',
        'ALPHA-2': 'GL',
        'ALPHA-3': 'GRL',
        NUMERIC: '304',
    },
    {
        name: 'Gambia',
        'ALPHA-2': 'GM',
        'ALPHA-3': 'GMB',
        NUMERIC: '270',
    },
    {
        name: 'Guinea',
        'ALPHA-2': 'GN',
        'ALPHA-3': 'GIN',
        NUMERIC: '324',
    },
    {
        name: 'Guadeloupe',
        'ALPHA-2': 'GP',
        'ALPHA-3': 'GLP',
        NUMERIC: '312',
    },
    {
        name: 'Equatorial Guinea',
        'ALPHA-2': 'GQ',
        'ALPHA-3': 'GNQ',
        NUMERIC: '226',
    },
    {
        name: 'Greece',
        'ALPHA-2': 'GR',
        'ALPHA-3': 'GRC',
        NUMERIC: '300',
    },
    {
        name: 'South Gerogia and the South Sandwich Islands',
        'ALPHA-2': 'GS',
        'ALPHA-3': 'SGS',
        NUMERIC: '239',
    },
    {
        name: 'Guatemala',
        'ALPHA-2': 'GT',
        'ALPHA-3': 'GTM',
        NUMERIC: '320',
    },
    {
        name: 'Guam',
        'ALPHA-2': 'GU',
        'ALPHA-3': 'GUM',
        NUMERIC: '316',
    },
    {
        name: 'Guinea-Bissau',
        'ALPHA-2': 'GW',
        'ALPHA-3': 'GNB',
        NUMERIC: '624',
    },
    {
        name: 'Guyana',
        'ALPHA-2': 'GY',
        'ALPHA-3': 'GUY',
        NUMERIC: '328',
    },
    {
        name: 'Hong Kong',
        'ALPHA-2': 'HK',
        'ALPHA-3': 'HKG',
        NUMERIC: '344',
    },
    {
        name: 'Heard Island and McDonald Islands',
        'ALPHA-2': 'HM',
        'ALPHA-3': 'HMD',
        NUMERIC: '334',
    },
    {
        name: 'Honduras',
        'ALPHA-2': 'HN',
        'ALPHA-3': 'HND',
        NUMERIC: '340',
    },
    {
        name: 'Croatia',
        'ALPHA-2': 'HR',
        'ALPHA-3': 'HRV',
        NUMERIC: '191',
    },
    {
        name: 'Haiti',
        'ALPHA-2': 'HT',
        'ALPHA-3': 'HTI',
        NUMERIC: '332',
    },
    {
        name: 'Hungary',
        'ALPHA-2': 'HU',
        'ALPHA-3': 'HUN',
        NUMERIC: '348',
    },
    {
        name: 'Indonesia',
        'ALPHA-2': 'ID',
        'ALPHA-3': 'IDN',
        NUMERIC: '360',
    },
    {
        name: 'Ireland',
        'ALPHA-2': 'IE',
        'ALPHA-3': 'IRL',
        NUMERIC: '372',
    },
    {
        name: 'Israel',
        'ALPHA-2': 'IL',
        'ALPHA-3': 'ISR',
        NUMERIC: '376',
    },
    {
        name: 'Isle of Man',
        'ALPHA-2': 'IM',
        'ALPHA-3': 'IMN',
        NUMERIC: '833',
    },
    {
        name: 'India',
        'ALPHA-2': 'IN',
        'ALPHA-3': 'IND',
        NUMERIC: '356',
    },
    {
        name: 'British Indian Ocean Territory',
        'ALPHA-2': 'IO',
        'ALPHA-3': 'IOT',
        NUMERIC: '086',
    },
    {
        name: 'Iraq',
        'ALPHA-2': 'IQ',
        'ALPHA-3': 'IRQ',
        NUMERIC: '368',
    },
    {
        name: 'Iran',
        'ALPHA-2': 'IR',
        'ALPHA-3': 'IRN',
        NUMERIC: '364',
    },
    {
        name: 'Iceland',
        'ALPHA-2': 'IS',
        'ALPHA-3': 'ISL',
        NUMERIC: '352',
    },
    {
        name: 'Italy',
        'ALPHA-2': 'IT',
        'ALPHA-3': 'ITA',
        NUMERIC: '380',
    },
    {
        name: 'Jersey',
        'ALPHA-2': 'JE',
        'ALPHA-3': 'JEY',
        NUMERIC: '832',
    },
    {
        name: 'Jamaica',
        'ALPHA-2': 'JM',
        'ALPHA-3': 'JAM',
        NUMERIC: '388',
    },
    {
        name: 'Jordan',
        'ALPHA-2': 'JO',
        'ALPHA-3': 'JOR',
        NUMERIC: '400',
    },
    {
        name: 'Japan',
        'ALPHA-2': 'JP',
        'ALPHA-3': 'JPN',
        NUMERIC: '392',
    },
    {
        name: 'Kenya',
        'ALPHA-2': 'KE',
        'ALPHA-3': 'KEN',
        NUMERIC: '404',
    },
    {
        name: 'Kyrgyzstan',
        'ALPHA-2': 'KG',
        'ALPHA-3': 'KGZ',
        NUMERIC: '417',
    },
    {
        name: 'Cambodia',
        'ALPHA-2': 'KH',
        'ALPHA-3': 'KHM',
        NUMERIC: '116',
    },
    {
        name: 'Kiribati',
        'ALPHA-2': 'KI',
        'ALPHA-3': 'KIR',
        NUMERIC: '296',
    },
    {
        name: 'Comoros',
        'ALPHA-2': 'KM',
        'ALPHA-3': 'COM',
        NUMERIC: '174',
    },
    {
        name: 'Saint Kitts and Nevis',
        'ALPHA-2': 'KN',
        'ALPHA-3': 'KNA',
        NUMERIC: '659',
    },
    {
        name: "Korea (the Democratic People's Republic of)",
        'ALPHA-2': 'KP',
        'ALPHA-3': 'PRK',
        NUMERIC: '408',
    },
    {
        name: 'Korea (the Republic of)',
        'ALPHA-2': 'KR',
        'ALPHA-3': 'KOR',
        NUMERIC: '410',
    },
    {
        name: 'Kuwait',
        'ALPHA-2': 'KW',
        'ALPHA-3': 'KWT',
        NUMERIC: '414',
    },
    {
        name: 'Cayman Islands',
        'ALPHA-2': 'KY',
        'ALPHA-3': 'CYM',
        NUMERIC: '136',
    },
    {
        name: 'Kazakhstan',
        'ALPHA-2': 'KZ',
        'ALPHA-3': 'KAZ',
        NUMERIC: '398',
    },
    {
        name: "The Lao People's Democratic Republic",
        'ALPHA-2': 'LA',
        'ALPHA-3': 'LAO',
        NUMERIC: '418',
    },
    {
        name: 'Lebanon',
        'ALPHA-2': 'LB',
        'ALPHA-3': 'LBN',
        NUMERIC: '422',
    },
    {
        name: 'Saint Lucia',
        'ALPHA-2': 'LC',
        'ALPHA-3': 'LCA',
        NUMERIC: '662',
    },
    {
        name: 'Liechtenstein',
        'ALPHA-2': 'LI',
        'ALPHA-3': 'LIE',
        NUMERIC: '438',
    },
    {
        name: 'Sri Lanka',
        'ALPHA-2': 'LK',
        'ALPHA-3': 'LKA',
        NUMERIC: '144',
    },
    {
        name: 'Liberia',
        'ALPHA-2': 'LR',
        'ALPHA-3': 'LBR',
        NUMERIC: '430',
    },
    {
        name: 'Lesotho',
        'ALPHA-2': 'LS',
        'ALPHA-3': 'LSO',
        NUMERIC: '426',
    },
    {
        name: 'Lithuania',
        'ALPHA-2': 'LT',
        'ALPHA-3': 'LTU',
        NUMERIC: '440',
    },
    {
        name: 'Luxembourg',
        'ALPHA-2': 'LU',
        'ALPHA-3': 'LUX',
        NUMERIC: '442',
    },
    {
        name: 'Latvia',
        'ALPHA-2': 'LV',
        'ALPHA-3': 'LVA',
        NUMERIC: '428',
    },
    {
        name: 'Libya',
        'ALPHA-2': 'LY',
        'ALPHA-3': 'LBY',
        NUMERIC: '434',
    },
    {
        name: 'Morocco',
        'ALPHA-2': 'MA',
        'ALPHA-3': 'MAR',
        NUMERIC: '504',
    },
    {
        name: 'Monaco',
        'ALPHA-2': 'MC',
        'ALPHA-3': 'MCO',
        NUMERIC: '492',
    },
    {
        name: 'Moldova',
        'ALPHA-2': 'MD',
        'ALPHA-3': 'MDA',
        NUMERIC: '498',
    },
    {
        name: 'Montenegro',
        'ALPHA-2': 'ME',
        'ALPHA-3': 'MNE',
        NUMERIC: '499',
    },
    {
        name: 'Saint Martin',
        'ALPHA-2': 'MF',
        'ALPHA-3': 'MAF',
        NUMERIC: '663',
    },
    {
        name: 'Madagascar',
        'ALPHA-2': 'MG',
        'ALPHA-3': 'MDG',
        NUMERIC: '450',
    },
    {
        name: 'Marshall Islands',
        'ALPHA-2': 'MH',
        'ALPHA-3': 'MHL',
        NUMERIC: '584',
    },
    {
        name: 'North Macedonia',
        'ALPHA-2': 'MK',
        'ALPHA-3': 'MKD',
        NUMERIC: '807',
    },
    {
        name: 'Mali',
        'ALPHA-2': 'ML',
        'ALPHA-3': 'MLI',
        NUMERIC: '466',
    },
    {
        name: 'Myanmar',
        'ALPHA-2': 'MM',
        'ALPHA-3': 'MMR',
        NUMERIC: '104',
    },
    {
        name: 'Mongolia',
        'ALPHA-2': 'MN',
        'ALPHA-3': 'MNG',
        NUMERIC: '496',
    },
    {
        name: 'Macao',
        'ALPHA-2': 'MO',
        'ALPHA-3': 'MAC',
        NUMERIC: '446',
    },
    {
        name: 'Northern Mariana Islands',
        'ALPHA-2': 'MP',
        'ALPHA-3': 'MNP',
        NUMERIC: '580',
    },
    {
        name: 'Martinique',
        'ALPHA-2': 'MQ',
        'ALPHA-3': 'MTQ',
        NUMERIC: '474',
    },
    {
        name: 'Mauritania',
        'ALPHA-2': 'MR',
        'ALPHA-3': 'MRT',
        NUMERIC: '478',
    },
    {
        name: 'Montserrat',
        'ALPHA-2': 'MS',
        'ALPHA-3': 'MSR',
        NUMERIC: '500',
    },
    {
        name: 'Malta',
        'ALPHA-2': 'MT',
        'ALPHA-3': 'MLT',
        NUMERIC: '470',
    },
    {
        name: 'Mauritius',
        'ALPHA-2': 'MU',
        'ALPHA-3': 'MUS',
        NUMERIC: '480',
    },
    {
        name: 'Maldives',
        'ALPHA-2': 'MV',
        'ALPHA-3': 'MDV',
        NUMERIC: '462',
    },
    {
        name: 'Malawi',
        'ALPHA-2': 'MW',
        'ALPHA-3': 'MWI',
        NUMERIC: '454',
    },
    {
        name: 'Mexico',
        'ALPHA-2': 'MX',
        'ALPHA-3': 'MEX',
        NUMERIC: '484',
    },
    {
        name: 'Malaysia',
        'ALPHA-2': 'MY',
        'ALPHA-3': 'MYS',
        NUMERIC: '458',
    },
    {
        name: 'Mozambique',
        'ALPHA-2': 'MZ',
        'ALPHA-3': 'MOZ',
        NUMERIC: '508',
    },
    {
        name: 'Namibia',
        'ALPHA-2': 'NA',
        'ALPHA-3': 'NAM',
        NUMERIC: '516',
    },
    {
        name: 'New Caledonia',
        'ALPHA-2': 'NC',
        'ALPHA-3': 'NCL',
        NUMERIC: '540',
    },
    {
        name: 'Niger',
        'ALPHA-2': 'NE',
        'ALPHA-3': 'NER',
        NUMERIC: '562',
    },
    {
        name: 'Norfolk Island',
        'ALPHA-2': 'NF',
        'ALPHA-3': 'NFK',
        NUMERIC: '574',
    },
    {
        name: 'Nigeria',
        'ALPHA-2': 'NG',
        'ALPHA-3': 'NGA',
        NUMERIC: '566',
    },
    {
        name: 'Nicaragua',
        'ALPHA-2': 'NI',
        'ALPHA-3': 'NIC',
        NUMERIC: '558',
    },
    {
        name: 'Netherlands',
        'ALPHA-2': 'NL',
        'ALPHA-3': 'NLD',
        NUMERIC: '528',
    },
    {
        name: 'Norway',
        'ALPHA-2': 'NO',
        'ALPHA-3': 'NOR',
        NUMERIC: '578',
    },
    {
        name: 'Nepal',
        'ALPHA-2': 'NP',
        'ALPHA-3': 'NPL',
        NUMERIC: '524',
    },
    {
        name: 'Nauru',
        'ALPHA-2': 'NR',
        'ALPHA-3': 'NRU',
        NUMERIC: '520',
    },
    {
        name: 'Niue',
        'ALPHA-2': 'NU',
        'ALPHA-3': 'NIU',
        NUMERIC: '570',
    },
    {
        name: 'New Zealand',
        'ALPHA-2': 'NZ',
        'ALPHA-3': 'NZL',
        NUMERIC: '554',
    },
    {
        name: 'Oman',
        'ALPHA-2': 'OM',
        'ALPHA-3': 'OMN',
        NUMERIC: '512',
    },
    {
        name: 'Panama',
        'ALPHA-2': 'PA',
        'ALPHA-3': 'PAN',
        NUMERIC: '591',
    },
    {
        name: 'Peru',
        'ALPHA-2': 'PE',
        'ALPHA-3': 'PER',
        NUMERIC: '604',
    },
    {
        name: 'French Polyesia',
        'ALPHA-2': 'PF',
        'ALPHA-3': 'PYF',
        NUMERIC: '258',
    },
    {
        name: 'Papua New Guinea',
        'ALPHA-2': 'PG',
        'ALPHA-3': 'PNG',
        NUMERIC: '598',
    },
    {
        name: 'Phillippines',
        'ALPHA-2': 'PH',
        'ALPHA-3': 'PHL',
        NUMERIC: '608',
    },
    {
        name: 'Pakistan',
        'ALPHA-2': 'PK',
        'ALPHA-3': 'PAK',
        NUMERIC: '586',
    },
    {
        name: 'Poland',
        'ALPHA-2': 'PL',
        'ALPHA-3': 'POL',
        NUMERIC: '616',
    },
    {
        name: 'Saint Pierre and Miquelon',
        'ALPHA-2': 'PM',
        'ALPHA-3': 'SPM',
        NUMERIC: '666',
    },
    {
        name: 'Pitcairn',
        'ALPHA-2': 'PN',
        'ALPHA-3': 'PCN',
        NUMERIC: '612',
    },
    {
        name: 'Puerto Rico',
        'ALPHA-2': 'PR',
        'ALPHA-3': 'PRI',
        NUMERIC: '630',
    },
    {
        name: 'Palestine, State of',
        'ALPHA-2': 'PS',
        'ALPHA-3': 'PSE',
        NUMERIC: '275',
    },
    {
        name: 'Portugal',
        'ALPHA-2': 'PT',
        'ALPHA-3': 'PRT',
        NUMERIC: '620',
    },
    {
        name: 'Palau',
        'ALPHA-2': 'PW',
        'ALPHA-3': 'PLW',
        NUMERIC: '585',
    },
    {
        name: 'Paraguay',
        'ALPHA-2': 'PY',
        'ALPHA-3': 'PRY',
        NUMERIC: '600',
    },
    {
        name: 'Qatar',
        'ALPHA-2': 'QA',
        'ALPHA-3': 'QAT',
        NUMERIC: '634',
    },
    {
        name: 'Reunion',
        'ALPHA-2': 'RE',
        'ALPHA-3': 'REU',
        NUMERIC: '638',
    },
    {
        name: 'Romania',
        'ALPHA-2': 'RO',
        'ALPHA-3': 'ROU',
        NUMERIC: '642',
    },
    {
        name: 'Serbia',
        'ALPHA-2': 'RS',
        'ALPHA-3': 'SRB',
        NUMERIC: '688',
    },
    {
        name: 'Russian Federation',
        'ALPHA-2': 'RU',
        'ALPHA-3': 'RUS',
        NUMERIC: '643',
    },
    {
        name: 'Rwanda',
        'ALPHA-2': 'RW',
        'ALPHA-3': 'RWA',
        NUMERIC: '646',
    },
    {
        name: 'Saudi Arabia',
        'ALPHA-2': 'SA',
        'ALPHA-3': 'SAU',
        NUMERIC: '682',
    },
    {
        name: 'Solomon Islands',
        'ALPHA-2': 'SB',
        'ALPHA-3': 'SLB',
        NUMERIC: '090',
    },
    {
        name: 'Seychelles',
        'ALPHA-2': 'SC',
        'ALPHA-3': 'SYC',
        NUMERIC: '690',
    },
    {
        name: 'Sudan',
        'ALPHA-2': 'SD',
        'ALPHA-3': 'SDN',
        NUMERIC: '729',
    },
    {
        name: 'Sweden',
        'ALPHA-2': 'SE',
        'ALPHA-3': 'SWE',
        NUMERIC: '752',
    },
    {
        name: 'Singapore',
        'ALPHA-2': 'SG',
        'ALPHA-3': 'SGP',
        NUMERIC: '702',
    },
    {
        name: 'Saint Helena, Ascension Island, Traistan da Cunha',
        'ALPHA-2': 'SH',
        'ALPHA-3': 'SHN',
        NUMERIC: '654',
    },
    {
        name: 'Slovenia',
        'ALPHA-2': 'SI',
        'ALPHA-3': 'SVN',
        NUMERIC: '705',
    },
    {
        name: 'Svalbard, Jan Mayen',
        'ALPHA-2': 'SJ',
        'ALPHA-3': 'SJM',
        NUMERIC: '744',
    },
    {
        name: 'Slovakia',
        'ALPHA-2': 'SK',
        'ALPHA-3': 'SVK',
        NUMERIC: '703',
    },
    {
        name: 'Sierra Leone',
        'ALPHA-2': 'SL',
        'ALPHA-3': 'SLE',
        NUMERIC: '694',
    },
    {
        name: 'San Marino',
        'ALPHA-2': 'SM',
        'ALPHA-3': 'SMR',
        NUMERIC: '674',
    },
    {
        name: 'Senegal',
        'ALPHA-2': 'SN',
        'ALPHA-3': 'SEN',
        NUMERIC: '686',
    },
    {
        name: 'Somalia',
        'ALPHA-2': 'SO',
        'ALPHA-3': 'SOM',
        NUMERIC: '706',
    },
    {
        name: 'Suriname',
        'ALPHA-2': 'SR',
        'ALPHA-3': 'SUR',
        NUMERIC: '740',
    },
    {
        name: 'South Sudan',
        'ALPHA-2': 'SS',
        'ALPHA-3': 'SSD',
        NUMERIC: '728',
    },
    {
        name: 'Sao Tome and Principe',
        'ALPHA-2': 'ST',
        'ALPHA-3': 'STP',
        NUMERIC: '678',
    },
    {
        name: 'El Salvador',
        'ALPHA-2': 'SV',
        'ALPHA-3': 'SLV',
        NUMERIC: '222',
    },
    {
        name: 'Sint Maarten',
        'ALPHA-2': 'SX',
        'ALPHA-3': 'SXM',
        NUMERIC: '534',
    },
    {
        name: 'Syrian Arab Republic',
        'ALPHA-2': 'SY',
        'ALPHA-3': 'SYR',
        NUMERIC: '760',
    },
    {
        name: 'Eswatini',
        'ALPHA-2': 'SZ',
        'ALPHA-3': 'SWZ',
        NUMERIC: '748',
    },
    {
        name: 'Turks and Caicos Islands',
        'ALPHA-2': 'TC',
        'ALPHA-3': 'TCA',
        NUMERIC: '796',
    },
    {
        name: 'Chad',
        'ALPHA-2': 'TD',
        'ALPHA-3': 'TCD',
        NUMERIC: '148',
    },
    {
        name: 'French Southern Territories',
        'ALPHA-2': 'TF',
        'ALPHA-3': 'ATF',
        NUMERIC: '260',
    },
    {
        name: 'Togo',
        'ALPHA-2': 'TG',
        'ALPHA-3': 'TGO',
        NUMERIC: '768',
    },
    {
        name: 'Thailand',
        'ALPHA-2': 'TH',
        'ALPHA-3': 'THA',
        NUMERIC: '764',
    },
    {
        name: 'Tajikistan',
        'ALPHA-2': 'TJ',
        'ALPHA-3': 'TJK',
        NUMERIC: '762',
    },
    {
        name: 'Tokelau',
        'ALPHA-2': 'TK',
        'ALPHA-3': 'TKL',
        NUMERIC: '772',
    },
    {
        name: 'Timor-Leste',
        'ALPHA-2': 'TL',
        'ALPHA-3': 'TLS',
        NUMERIC: '626',
    },
    {
        name: 'Turkmenistan',
        'ALPHA-2': 'TM',
        'ALPHA-3': 'TKM',
        NUMERIC: '795',
    },
    {
        name: 'Tunisia',
        'ALPHA-2': 'TN',
        'ALPHA-3': 'TUN',
        NUMERIC: '788',
    },
    {
        name: 'Tonga',
        'ALPHA-2': 'TO',
        'ALPHA-3': 'TON',
        NUMERIC: '776',
    },
    {
        name: 'Turkey',
        'ALPHA-2': 'TR',
        'ALPHA-3': 'TUR',
        NUMERIC: '792',
    },
    {
        name: 'Trinidad and Tobago',
        'ALPHA-2': 'TT',
        'ALPHA-3': 'TTO',
        NUMERIC: '780',
    },
    {
        name: 'Tuvalu',
        'ALPHA-2': 'TV',
        'ALPHA-3': 'TUV',
        NUMERIC: '798',
    },
    {
        name: 'Taiwan',
        'ALPHA-2': 'TW',
        'ALPHA-3': 'TWN',
        NUMERIC: '158',
    },
    {
        name: 'Tanzania, the United Republic of',
        'ALPHA-2': 'TZ',
        'ALPHA-3': 'TZA',
        NUMERIC: '834',
    },
    {
        name: 'Ukraine',
        'ALPHA-2': 'UA',
        'ALPHA-3': 'UKR',
        NUMERIC: '804',
    },
    {
        name: 'Uganda',
        'ALPHA-2': 'UG',
        'ALPHA-3': 'UGA',
        NUMERIC: '800',
    },
    {
        name: 'United States Minor Outlying Islands',
        'ALPHA-2': 'UM',
        'ALPHA-3': 'UMI',
        NUMERIC: '581',
    },
    // {name: 'Union of South American Nations', 'ALPHA-2': 'UNASUR', 'ALPHA-3': '', NUMERIC: ''},
    {
        name: 'United States of America',
        'ALPHA-2': 'US',
        'ALPHA-3': 'USA',
        NUMERIC: '840',
    },
    {
        name: 'Uruguay',
        'ALPHA-2': 'UY',
        'ALPHA-3': 'URY',
        NUMERIC: '858',
    },
    {
        name: 'Uzbekistan',
        'ALPHA-2': 'UZ',
        'ALPHA-3': 'UZB',
        NUMERIC: '860',
    },
    {
        name: 'Holy See',
        'ALPHA-2': 'VA',
        'ALPHA-3': 'VAT',
        NUMERIC: '336',
    },
    {
        name: 'Saint Vincent and the Grenadines',
        'ALPHA-2': 'VC',
        'ALPHA-3': 'VCT',
        NUMERIC: '670',
    },
    {
        name: 'Venezuela (Bolivarian Republic of)',
        'ALPHA-2': 'VE',
        'ALPHA-3': 'VEN',
        NUMERIC: '862',
    },
    {
        name: 'Virgin Islands (British)',
        'ALPHA-2': 'VG',
        'ALPHA-3': 'VGB',
        NUMERIC: '092',
    },
    {
        name: 'Virgin Islands (U.S.)',
        'ALPHA-2': 'VI',
        'ALPHA-3': 'VIR',
        NUMERIC: '850',
    },
    {
        name: 'Vietnam',
        'ALPHA-2': 'VN',
        'ALPHA-3': 'VNM',
        NUMERIC: '704',
    },
    {
        name: 'Vanuatu',
        'ALPHA-2': 'VU',
        'ALPHA-3': 'VUT',
        NUMERIC: '548',
    },
    {
        name: 'Wallis and Futuna',
        'ALPHA-2': 'WF',
        'ALPHA-3': 'WLF',
        NUMERIC: '876',
    },
    {
        name: 'Samoa',
        'ALPHA-2': 'WS',
        'ALPHA-3': 'WSM',
        NUMERIC: '882',
    },
    {
        name: 'Yemen',
        'ALPHA-2': 'YE',
        'ALPHA-3': 'YEM',
        NUMERIC: '887',
    },
    {
        name: 'South Africa',
        'ALPHA-2': 'ZA',
        'ALPHA-3': 'ZAF',
        NUMERIC: '710',
    },
    {
        name: 'Zambia',
        'ALPHA-2': 'ZM',
        'ALPHA-3': 'ZMB',
        NUMERIC: '894',
    },
    {
        name: 'Zimbabwe',
        'ALPHA-2': 'ZW',
        'ALPHA-3': 'ZWE',
        NUMERIC: '716',
    },

    {
        name: 'Algeria',
        'ALPHA-2': 'DZ',
        'ALPHA-3': 'DZA',
        NUMERIC: '013',
    },
    {
        name: 'Mayotte',
        'ALPHA-2': 'YT',
        'ALPHA-3': 'MYT',
        NUMERIC: '175',
    },
    { name: 'Kosovo', 'ALPHA-2': 'XK', 'ALPHA-3': 'XKK' },
];

export const useCountryOptions = () => {
    const { i18n } = useTranslation();

    return useMemo(
        () =>
            countries
                .map((item) => ({
                    label: i18nCountries.getName(item['ALPHA-2'], i18n.language) || '',
                    value: item['ALPHA-2'],
                }))
                .sort((a, b) => {
                    if (a.label > b.label) return 1;
                    if (a.label < b.label) return -1;

                    return 0;
                }),
        [i18n.language],
    ) as AutocompleteOption[];
};

export const useFindCountryByAlpha3 = (alpha3?: string | unknown) =>
    alpha3 ? countries.find((country) => country['ALPHA-3'] === alpha3) : undefined;

export const useFindCountryByAlpha2 = () => {
    const getCountryByAlpha2 = useCallback(
        (alpha2?: string | unknown) =>
            alpha2 ? countries.find((country) => country['ALPHA-2'] === alpha2) : undefined,
        [],
    );

    return { getCountryByAlpha2 };
};
